export { default } from "./generateUtilityClass.mjs";
export * from "./generateUtilityClass.mjs";